export const invertRanking = (ranking: number, maxRanking: number): number => {
  return (maxRanking + 1) - ranking;
};